<template>
  <v-container fluid>
    <div class="toolbar d-flex flex-row justify-space-between align-center elevation-3 mb-3">
      <span>
        Lazada Products List
      </span>
      <div class="d-flex">
        <v-select
          v-model="brandSelected"
          label="Brand"
          :items="allBrand"
          outlined
          dense
          class="mr-2"
          hide-details
          @change="getItems(true)" />
        <v-text-field
          v-model.trim="inputSearch"
          hide-details
          label="Search"
          append-icon="mdi-magnify"
          dense
          outlined
          @keydown.enter="getItems(true)">
        </v-text-field>
        <v-btn
          color="success"
          class="ml-2"
          :loading="loading || syncing"
          :to="{ name: 'LazadaCreateProduct' }">
          <v-icon>
            mdi-plus
          </v-icon>
          {{ $t('button.Add') }}
        </v-btn>
        <v-btn
          v-if="isDeveloper"
          color="secondary"
          class="ml-2"
          :loading="syncing"
          :disabled="loading"
          @click="syncAllStock()">
          <v-icon>
            mdi-sync
          </v-icon>
          Sync Stock
        </v-btn>
      </div>
    </div>

    <v-row class="px-8">
      <v-col
        cols="12"
        class="card-container elevation-3">
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="total"
          :loading="loading"
          :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
          @update:options="getItems()">
          <template #[`item.mainImageUrls`]="{ item }">
            <v-img
              :src="item.mainImageUrls[0]"
              width="100"
              height="100"
              contain
              class="my-2" />
          </template>
          <template #[`item.name`]="{ item }">
            <div class="d-flex flex-column py-2">
              <span class="mb-2 font-weight-bold">
                {{ item.name }}
              </span>
              <span>
                Models:
                <v-chip
                  v-for="(model, index) in item.models"
                  :key="`model-${index}`"
                  class="ma-1"
                  style="border-radius: 1rem !important;"
                  color="teal"
                  text-color="white"
                  small
                  label>
                  {{ model }}
                </v-chip>
              </span>
              <span class="uppercase">
                Colors: {{ item.colors.join(', ') || 'ไม่ระบุ' }}
                <!-- <v-chip
                  v-for="(color, index) in item.colors"
                  :key="`color-${index}`"
                  class="ma-1 capitalize"
                  color="teal"
                  text-color="white"
                  small
                  label>
                  {{ color }}
                </v-chip> -->
              </span>
              <span class="uppercase">
                Sizes: {{ item.sizes.join(', ') || 'ไม่ระบุ' }}
                <!-- <v-chip
                  v-for="(size, index) in item.sizes"
                  :key="`size-${index}`"
                  class="ma-1 uppercase"
                  color="teal"
                  text-color="white"
                  small
                  label>
                  {{ size }}
                </v-chip> -->
              </span>
            </div>
          </template>
          <template #[`item.stockStatus`]="{ item }">
            <div class="d-flex flex-column justify-center align-center">
              <v-chip
                style="border-radius: 1rem !important;"
                color="#FAE4E3"
                text-color="error"
                small
                label>
                NOT SYNC
              </v-chip>
              <!-- <v-chip
                style="border-radius: 1rem !important;"
                color="#e3f5e6"
                text-color="success"
                small
                label>
                SYNCED
              </v-chip> -->
              <span>
                ({{ item.updatedAt | dateTimeUserFormat }})
              </span>
            </div>
          </template>
          <template #[`item.price`]="{ item }">
            {{ item.price | showFullPriceFormat() }} THB
          </template>
          <template #[`item.action`]="{ item }">
            <div class="d-flex flex-row justify-center align-center">
              <v-btn
                color="success"
                small
                icon
                :loading="syncing"
                @click="syncStock(item.lazadaProductId)">
                <v-icon small>
                  mdi-sync
                </v-icon>
              </v-btn>
              <v-btn
                color="secondary"
                small
                icon
                :to="`products/${item.lazadaProductId}`">
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getRole } from '@/assets/js/Authentication'
import SizeValues from '@/assets/js/SizeValues'
import LazadaProvider from '@/resources/LazadaProvider.js'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'

const ProductAttributeService = new ProductAttributeProvider()
const LazadaService = new LazadaProvider()
export default {
  data () {
    return {
      headers: [
        {
          text: 'รูปภาพ',
          value: 'mainImageUrls',
          width: '100',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          sortable: false
        },
        {
          text: 'Lazada Product Id',
          value: 'lazadaProductId',
          sortable: false,
          align: 'center'
        },
        // {
        //   text: 'Stock status',
        //   value: 'stockStatus',
        //   sortable: false,
        //   align: 'center'
        // },
        {
          text: 'ราคา',
          value: 'price',
          sortable: false,
          align: 'right'
        },
        {
          text: 'ตัวเลือก',
          value: 'action',
          width: '100',
          sortable: false,
          align: 'center'
        }
      ],
      items: [],
      brandSelected: 'Gentlewoman',
      allBrand: ['Gentlewoman'],
      inputSearch: '',
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      loading: false,
      syncing: false
    }
  },
  computed: {
    isDeveloper () {
      return getRole() === 'developer'
    }
  },
  watch: {
    'query.page': {
      handler () {
        this.getItems()
      },
      deep: true
    }
  },
  async mounted () {
    await this.getAttribute()
    await this.getItems(true)
  },
  methods: {
    sortSize (sizes) {
      return sizes.sort((a, b) => SizeValues(a) - SizeValues(b))
    },
    async getItems (isClear = false) {
      try {
        this.loading = true

        if (isClear) {
          this.items = []
          this.options.page = 1
        }

        const { data } = await LazadaService.getProductList({
            page: this.options.page,
            brand: this.brandSelected,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
            search: this.inputSearch
          })

        this.items = (data?.results || []).map((item) => ({
            ...item,
            sizes: this.sortSize(item.sizes)
          }))
        this.total = data?.total || 0
      } catch (error) {
        console.error('getItems', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async getAttribute () {
      try {
        this.loading = true

        const { data: brands } = await ProductAttributeService.getProductAttribute('brands', {
          limit: 9999,
          sortBy: 'createdAt',
          sortOrder: 'asc'
        })

        this.allBrand = brands.results.map((brand) => brand.name)
      } catch (error) {
        console.error('brands: ', error)
      } finally {
        this.loading = false
      }
    },
    async syncAllStock () {
      try {
        this.syncing = true

        await LazadaService.syncAllStock({ brand: this.brandSelected })

        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Sync all stock successfully',
          type: 'success'
        })
      } catch (error) {
        console.error('syncAllStock', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.syncing = false
      }
    },
    async syncStock (id) {
      try {
        this.syncing = true

        await LazadaService.syncProductStock(id, { brand: this.brandSelected })

        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Sync stock successfully',
          type: 'success'
        })

        // this.getItems(true)
      } catch (error) {
        console.error('syncStock', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.syncing = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: sticky;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: #fff;
  padding: 1.25rem 1.875rem;
  border-radius: 0.625rem;
}
.toolbar span {
  font-weight: bold;
  font-size: 1.25rem;
}
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
  margin-top: 1.25rem;
  min-height: calc(100vh - 200px);
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
.paginate-container {
  padding: 0.25rem;
  background-color: #fff;
  border-radius: 1rem;
  margin-top: 0.5rem;
}
</style>

<style>
.search-box .v-input__control {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
.search-box .v-input__slot {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
</style>
